import { useEffect } from "react";
import { CommonActions, type NavigationProp } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import type { ChatStackParamList, MainTabParamList } from "../../types";

type Props = NativeStackScreenProps<ChatStackParamList, "ProcedureDetail">;

/**
 * Procedures and tests share one factsheet model. The Access screen owns the
 * canonical tabbed surface so a procedure can keep its own education while
 * still linking to any canonical tests it produces or supports.
 */
export default function ProcedureDetailScreen({ route, navigation }: Props) {
  useEffect(() => {
    const returnTab = route.params.returnTab ?? "Learn";
    navigation.getParent<NavigationProp<MainTabParamList>>()?.dispatch(
      CommonActions.navigate({
        name: "Access",
        params: {
          screen: "CanonicalTestFactsheet",
          params: {
            procedureId: route.params.procedureId,
            returnTab,
          },
        },
      }),
    );
  }, [navigation, route.params.procedureId, route.params.returnTab]);

  return null;
}
